<template>
  <div>
    {{ /* rff:coverageHistoryClientTab  */ }}
    <tf-tabs
      v-show="$ld.checkFlags(coverageHistoryClientTab)"
      id="tabs-history-types"
      :value="$route.name"
      @tab-click="$router.push({ name: $event.name })"
    >
      <tf-tab-pane
        v-for="({ type, routeName }) in tabs"
        :key="routeName"
        :disabled="
          (routeName === 'CoverageHistory' && !employerInfo.past_coverage_detail_available)
            || (routeName === 'MarketingHistory' && !employerInfo.has_client_history)"
        :name="routeName"
        :label="`${$options.filters.capitalize(type)} history`"
      />
    </tf-tabs>
    <router-view />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { coverageHistoryClientTab } from '@/utils/featureFlags';

  /**
   * The "Client History" view is a parent page with different types of client histories shown within a tab.
   *
   * @vuedoc
   * @exports ClientHistory
   * @category Views
   */
  export default {
    name: 'ClientHistory',
    data: () => ({
      coverageHistoryClientTab,
      tabs: [
        {
          routeName: 'CoverageHistory',
          type: 'coverage',
        },
        {
          routeName: 'MarketingHistory',
          type: 'marketing',
        },
      ],
    }),
    computed: {
      ...mapState({
        employerInfo: (state) => state.employer.employerInfo,
      }),
    },
  };
</script>

<style scoped lang="scss">
  #tabs-history-types {
    margin: 30px 0;
  }
</style>
